import { Component, inject } from '@angular/core';
import { NurseryTruckParameterService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  NurseryTruckParameterCreateDto,
  NurseryTruckParameterDto,
  NurseryTruckParameterExcelDownloadDto,
  NurseryTruckParameterUpdateDto,
} from '../proxy/general/dtos/nursery-truck-parameter';
import { NURSERYTRUCKPARAMETER_CONFIG, NURSERYTRUCKPARAMETER_FIELDS } from './nursery-truck-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nursery-truck-parameter',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, NurseryTruckParameterService, ConfirmationService],
  templateUrl: './nursery-truck-parameter.html',
  styleUrl: './nursery-truck-parameter.scss',
})
export class NurseryTruckParameter extends BaseHierarchicalCrudComponent<
  NurseryTruckParameterDto,
  NurseryTruckParameterCreateDto,
  NurseryTruckParameterUpdateDto,
  NurseryTruckParameterExcelDownloadDto
> {
  service = inject(NurseryTruckParameterService);
  config = NURSERYTRUCKPARAMETER_CONFIG;
  fields = NURSERYTRUCKPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: NurseryTruckParameterDto): NurseryTruckParameterUpdateDto {
    return {
      capacity: data.capacity,
      unitOfMeasureId: data.unitOfMeasureId,
      truckId: data.truckId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'NurseryTruckParameter';
  }
}
